<div class="container-fluid">
  <div class="row mt-3">
    <div class="col">
      <h3>Select a Site</h3>
      <hr />
      <ul>
        <li>Below, select a site to attach contract to.</li>
        <li>
          Once site is selected, a form will be populated with the Site's
          Primary Contact
        </li>
        <li>
          You can edit the form to use your own contact for this contract if you
          would like.
        </li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col" style="height: 500px">
      <app-sites-grid
        [gridName]="'ClientSites'"
        [selectedRowsPrimaryKeys]="selectedRowsPrimaryKeys"
        (selectionChanged)="onSiteSelectionChange($event)"
      ></app-sites-grid>
    </div>
  </div>

  @if (selectedSite) {
    <div class="row mt-3">
      <div class="col">
        <h3>Choose Primary Site Contact</h3>
        <!-- <div class="form-check ms-3">
        <label for="siteUserContact" class="form-label">Use Site User?</label>
        <input id="siteUserContact" type="checkbox" class="form-check-input">
      </div> -->
      </div>
      <hr />
    </div>
  }
  @if (selectedSite) {
    <div class="row" [formGroup]="siteContactForm">
      <div class="col">
        <div class="row g-3">
          <div class="col-4">
            <label for="firstName" class="form-label" requiredAsterisk
              >First Name</label
            >
            <input
              type="text"
              class="form-control"
              id="firstName"
              formControlName="firstName"
            />
          </div>
          <div class="col-4">
            <label for="lastName" class="form-label" requiredAsterisk
              >Last Name</label
            >
            <input
              type="text"
              class="form-control"
              id="lastName"
              formControlName="lastName"
            />
          </div>
          <div class="col-4">
            <label for="jobTitle" class="form-label">Job Title</label>
            <input
              type="text"
              class="form-control"
              id="jobTitle"
              formControlName="jobTitle"
            />
          </div>
        </div>
        <div class="row g-3">
          <div class="col-3">
            <label for="phone1" class="form-label" requiredAsterisk
              >Mobile / Primary Phone</label
            >
            <input
              type="tel"
              class="form-control"
              id="phone1"
              placeholder="(___)___-____"
              [inputMask]="phoneMask"
              formControlName="phone1"
            />
          </div>
          <div class="col">
            <label for="ext" class="form-label">Ext.</label>
            <input
              type="tel"
              class="form-control"
              id="ext"
              formControlName="ext"
            />
          </div>
          <div class="col-3">
            <label for="phone2" class="form-label"
              >Work / Secondary Phone</label
            >
            <input
              type="tel"
              class="form-control"
              id="phone2"
              placeholder="(___)___-____"
              [inputMask]="phoneMask"
              formControlName="phone2"
            />
          </div>
          <div class="col">
            <label for="ext2" class="form-label">Ext.</label>
            <input
              type="tel"
              class="form-control"
              id="ext2"
              formControlName="ext2"
            />
          </div>
          <div class="col-3">
            <label for="email" class="form-label" requiredAsterisk>Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
            />
          </div>
        </div>
        <div class="row" formGroupName="StreetAddress">
          <div class="col-3">
            <label for="contactAddress" class="form-label" requiredAsterisk
              >Address</label
            >
            <input
              type="text"
              class="form-control"
              id="contactAddress"
              formControlName="address1"
            />
          </div>
          <div class="col-3">
            <label for="contactAddress2" class="form-label">Address 2</label>
            <input
              type="text"
              class="form-control"
              id="contactAddress2"
              formControlName="address2"
            />
          </div>
          <div class="col-2">
            <label for="contactCity" class="form-label" requiredAsterisk
              >City</label
            >
            <input
              type="text"
              class="form-control"
              id="contactCity"
              formControlName="city"
            />
          </div>
          <div class="col-2">
            <label for="contactState" class="form-label" requiredAsterisk>{{
              localizationInfo && localizationInfo.territory
                ? localizationInfo.territory.label
                : 'State'
            }}</label>
            <select class="form-select" formControlName="state">
              @for (item of states; track item) {
                <option [ngValue]="item.abbreviation">
                  {{ item.name }}
                </option>
              }
            </select>
          </div>
          <div class="col-2">
            <label for="contactZip" class="form-label" requiredAsterisk>{{
              localizationInfo && localizationInfo.postalCode
                ? localizationInfo.postalCode.label
                : 'Zip'
            }}</label>
            <input
              type="text"
              class="form-control"
              id="contactZip"
              formControlName="zip"
              placeholder="{{
                localizationInfo && localizationInfo.postalCode.format
                  ? localizationInfo.postalCode.format
                  : ''
              }}"
              [inputMask]="zipMask"
            />
          </div>
        </div>
      </div>
    </div>
  }
</div>
